import { PropsWithChildren } from "react";
import clsx from "clsx";

export function EngravedText({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <div
      className={clsx(
        "font-bold text-[#323232] text-11 text-center uppercase tracking-tight",
        className,
      )}
      style={{
        WebkitTextStroke: "1px rgba(255, 255, 255, .2)",
      }}
    >
      {children}
    </div>
  );
}
